export default function ticketsQuantityhandler() {
	const input = document.querySelector(
		'.tribe-tickets__tickets-item-quantity-number-input'
	);

	if (!input) return;

	// Simuler saisie utilisateur complète
	input.value = 1;

	// Déclenche tous les événements comme si l’utilisateur avait interagi
	['input', 'change', 'keyup', 'blur'].forEach((eventName) => {
		input.dispatchEvent(new Event(eventName, { bubbles: true }));
	});

	// Attendre que Tribe ait terminé d'initialiser
	setTimeout(() => {
		// Activer le bouton si bloqué
		const submit = document.getElementById('tribe-tickets__tickets-submit');
		if (submit) {
			submit.disabled = false;
			submit.removeAttribute('aria-disabled');
		}

		// Masquer les contrôles de quantité
		const wrapper = document.querySelector(
			'.tribe-tickets__tickets-item-quantity'
		);
		if (wrapper) wrapper.style.display = 'none';
	}, 400); // 400ms pour laisser le DOM se stabiliser
}
